import React, { Component } from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { bellImage } from 'views/practitioner/services/svgImages';

// Constants
import { ROLES } from 'services/constants';

// Actions
import { uiTriggerDrawer } from 'store/ui-reducer';

// Styles
import styles from './styles';

const textRender = (count, i18n) => {
  let message = '';
  if (count) {
    message = `${count} ${count === 1 ? i18n.t('event_available') : i18n.t('events_available')}`;
  }
  return count ? <span className="msg">{message}</span> : null;
};

export class EventsBlock extends Component {
  clickOnBlock() {
    const { unplannedList, uiTriggerDrawer } = this.props;
    if (Array.isArray(unplannedList) && unplannedList.length) {
      uiTriggerDrawer();
    }
  }

  render() {
    const { unplannedList, i18n, role } = this.props;
    const count = Array.isArray(unplannedList) && unplannedList.length;
    return (role !== ROLES.RADIOLOGY ?
      <styles.EventsBlockWrapper isActive={count} onClick={this.clickOnBlock.bind(this)}>
        {bellImage(count, count)}
        {textRender(count, i18n)}
      </styles.EventsBlockWrapper> : null
    );
  }
}

const mapStateToProps = state => ({
  role: state.auth.role,
  unplannedList: state.practitioner.appointments.unplannedList
});

export default translate()(
  connect(
    mapStateToProps,
    { uiTriggerDrawer }
  )(EventsBlock)
);
